export const UNLOADED = "UNLOADED";
export const LOADING = "LOADING";
export const LOADED = "LOADED";
export const ERROR = "ERROR";
export const SUCCESS = "SUCCESS";
export const PENDING = "PENDING";
